var map = {
	"./cytz.png": "8d3b",
	"./diwen.png": "b373",
	"./hysc.png": "df9d",
	"./jggpc.png": "73b8",
	"./jinbi.png": "c66b",
	"./jspc.png": "0706",
	"./logo.png": "ead5",
	"./nwwd.png": "1e5c",
	"./pcjj.png": "9b26",
	"./xspc.png": "af12",
	"./zmjl.png": "3f89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1bbb";